import React, {Fragment} from "react";
import {AdminUserService} from "../../services/AdminUserService";
import {ActionType} from "../list/list/DataTable";
import {AdminUser, ListAdminUsersRequest, ListAdminUsersResponse, UserGroup} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {createInitialState, ListView, ListViewProps, ListViewState} from "../ListView";
import { UserGroupService } from "../../services/UserGroupService";
import {Form} from "../form/Form";
import { Submit } from "../form/Submit";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {SelectInput} from "../form/SelectInput";


interface State extends ListViewState<ListAdminUsersRequest> {
    listRequest? : ListAdminUsersRequest;
    form? : ListAdminUsersRequest;
    validationMap? : any;
    lookupExpanded?: boolean;
    userGroup?: UserGroup[]; 
}
interface Props extends ListViewProps  {

}

export class AdminUserListView extends ListView<State, ListAdminUsersRequest> {

    columns = [
        { property : "id", name : "ID", orderBy : "ID"},
        { property : "alias", name : "Alias" },
        { property : "email", name : "E-mail", orderBy : "email"},
        { property : "firstName", name : "First Name" },
        { property : "lastName", name : "Last Name" },
    ];

    actions = [
        { id : "view", name : "View", className : "btn btn-primary", iconClassName : "fa fa-eye", type : ActionType.LINK, getLink : (item : any) => "/admin/admin-user/" + item.id }
    ];

    adminDashboardUserService : AdminUserService;
    userGroupService: UserGroupService;

    initialState : ListAdminUsersRequest = {
        limit: 20,
        orderBy: "id",
        ascending: false,
        email: undefined,
        firstName: undefined,
        lastName: undefined,
        alias: undefined,
        userGroupId: undefined
    }

    constructor(props : Props){
        super(props, "/admin/admin-users");
        this.adminDashboardUserService = getContainer().getAdminUserService();
        this.userGroupService = getContainer().getUserGroupService();
        let locProp = this.props.location;
        if (this.state.listRequest){
            let userGroupId:[] = [];
            if(locProp.state && this.state.listRequest) {
                userGroupId = locProp.state.listRequest.userGroupId && locProp.state.listRequest.userGroupId;
            }            
            this.initialState.userGroupId = userGroupId;

            this.state = createInitialState(
                this.initialState,
                this.state = {lookupExpanded:false,  ...this.state});
        }
    }

    loadContent() : Promise<any> | undefined {
        let listRequest : ListAdminUsersRequest = { limit:1000,offset:0, orderBy : "id", ascending : false };
            return Promise.all<any>([
                this.userGroupService.list(listRequest)

            ]).then( res => {
                let groups : ListAdminUsersResponse = res[0];
                this.setState({loading : false, userGroup : groups.items });
        });
    }

    onAction(item : AdminUser, action : string) : undefined {
        return undefined;
    }

    onSubmit(): void {
        let listRequest : ListAdminUsersRequest = Object.assign({},this.state.form);
        listRequest.offset = 0;
        this.updateListState(listRequest);
    };

    formDidUpdate(formModel: ListAdminUsersRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    clearForAdvanced() {
        this.setState({form: {...this.state.form}})

    }

    onSubmitError() :  void {
        console.log("submit error!")
    }

    clearFilter() {
        this.setState({form: {}})
    }

    //Metodo clave para convertir user group array to values array
    convertUserGroupToValueArray(group?: UserGroup[] | undefined){        
        return group!.map(function(item) {
            return item.name;
        });
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            console.log("pager changed!", pager);
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.updateListState(listRequest);
        }
    }
    getTitle() {
        return "List Admin Users"
    }

    getSearchByFilter() {
        console.log(this.state.userGroup);
        return(
            <div className="card-box expandable-box" style={!this.state.lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !this.state.lookupExpanded ? this.setState({lookupExpanded:true}) : null}>
                {this.state.lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e)=>{ e.preventDefault(); this.setState({lookupExpanded : false})}}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.lookupExpanded && (
                    <a href="/#"  className="expand-button float-right" onClick={(e)=>{e.preventDefault(); this.setState({lookupExpanded : true})}}><i className="mdi mdi-plus"></i></a>
                )}
                <h4 className="header-title mb-3" onClick={()=>this.setState({lookupExpanded : !this.state.lookupExpanded})}>Advanced Search</h4>
                {this.state.lookupExpanded && (
                    <div>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <label htmlFor={"alias"}>Alias</label>
                                    <FormGroup className="form-group" model="alias">
                                        <FormInput className="form-control col-lg-6"  id={"alias"} model="alias" type="text" />
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6">
                                    <FormGroup className="form-group" model="userGroupId">
                                    <label>User Groups</label>
                                        <SelectInput className="form-control  col-lg-4"
                                            model="userGroupId" 
                                            size={this.state.userGroup!.length} 
                                            values={[...Object.values(this.convertUserGroupToValueArray(this.state.userGroup))]}  
                                            multiple={true}
                                            optional={true}
                                            onFocus={() => this.clearForAdvanced()}/>
                                        <span className={"help-text"}>Search for user based on their user groups. CTRL select for multiple groups.</span>
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="form-group">
                                    <Submit className={"btn btn-primary"}>Search</Submit>
                                    <button onClick={() => this.clearFilter()} className={"btn btn-secondary"}>Clear</button>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        );
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                {this.getSearchByFilter()}
                <EntityDataTable service={this.adminDashboardUserService}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }

}

export default withRouter(AdminUserListView);
